import Swiper, { A11y, Navigation, Pagination } from 'swiper';
import { createMediaQueryList, getBreakpoint } from '../utils/_breakpoints';
import { getDataProperty } from '../utils/_domFunctions';

class mPdCarrousel extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
        this.mqlDesktop = createMediaQueryList('md');
        this.mobileLayout = getDataProperty(this, 'mobileLayout', 'string', 'mosaic');
    }

    connectedCallback() {
        this.initSlider();
    }

    disconnectedCallback() {}

    initSlider() {
        let slidesPerGroup = 4;
        let slidesPerView = 4;
        let breakpoints = null;

        if (this.mobileLayout === 'single') {
            this.classList.add('single-layout-mobile');
            slidesPerGroup = 1;
            slidesPerView = 1.5;
            const bpDesktop = getBreakpoint('md').minWidth.replace('px', '');
            breakpoints = {
                [bpDesktop]: {
                    slidesPerGroup: 4,
                    slidesPerView: 4,
                },
            };
        }

        this.slider = new Swiper(this, {
            modules: [A11y, Navigation, Pagination],
            slidesPerGroup,
            slidesPerView,
            spaceBetween: 0,
            breakpoints,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });

        if (this.mobileLayout === 'mosaic') {
            this.classList.add('mosaic-layout-mobile');
            this.mqlDesktop.addEventListener('change', this.updateMosaicLayout.bind(this));
            this.updateMosaicLayout();
        }
    }

    updateMosaicLayout() {
        const isDesktop = this.mqlDesktop.matches;

        if (isDesktop) {
            this.slider.enable();
        } else {
            this.slider.disable();
        }
    }
}
customElements.define('m-pd-carrousel', mPdCarrousel, {
    extends: 'div',
});
